import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import SigninUseridRepository from '@/repositories/signinUseridRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';

export const useSigninUseridStore = defineStore({
    id: 'signinUserid',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * ユーザーID通知APIをコールする。
         * @param {signinUseridApplyForm} request
         * @returns response
         */
        async sendMailUserIdNoticeAction(API_URL, requestBody) {
            const signinUseridRepository = new SigninUseridRepository();
            try {
                const response = await signinUseridRepository.getUserIdsApi(API_URL, requestBody);
                //this.medicalQuestionnarieForm = response.data;
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
});
